import { render, staticRenderFns } from "./invoice-detail.html?vue&type=template&id=667d46b4&scoped=true&external"
import script from "./invoice-detail.js?vue&type=script&lang=js&external"
export * from "./invoice-detail.js?vue&type=script&lang=js&external"
import style0 from "./invoice-detail.scss?vue&type=style&index=0&id=667d46b4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d46b4",
  null
  
)

export default component.exports